module.exports = __webpack_public_path__ + "img/Molit_Logo.49cab954.png";